export default __webpack_public_path__ + "static/media/innova.af314a11.png";